module.exports = __webpack_public_path__ + "img/banner-2-new.aa13a4d4.svg";